import {makeStyles} from "@material-ui/core/styles";
import {topHeight} from "../../../../../../stores/NavigateStore";


export const  useStyles = makeStyles((theme) => ({
    root:{
        width: '100%',
    },
    emptyBox:{
        width: '100%',
        height: `calc(100vh - ${topHeight}px - 36px - 20px - 24px - 24px)`,
        display:'flex',
        alignItems: 'center',
        justifyContent: 'center',
        '& p':{
            fontSize: '1.375rem',
            color: '#87888d',
            fontWeight:400,
            textAlign: 'center',
            lineHeight: '30.36px'
        }
    },
    boxWrap: {
        backgroundColor: '#fff',
        padding: 20,
        borderRadius: 8,
    },
    tabBox: {
        '& .MuiTabs-root':{
            minHeight: 40,
        },
        '& .MuiTab-root':{
            minWidth: 70,
        },
        '& .MuiTabs-flexContainer': {
            // width: 248,
            borderBottom: '1px solid #bbbbbb',
            borderRadius: 0,
            overflow: 'hidden'
        },
        '& button': {
            width: 70,
            minHeight: 40,
            height: 40,
            position: 'relative',
            fontSize: '1.063rem',
            fontWeight: 500,
            letterSpacing: '-0.5px',
            color:'#323232',
            boxSizing: 'border-box',
            padding:0,
        },
        '& button.Mui-selected': {
            fontWeight: 600,
            color: '#5579f0',
            opacity: 1,
            boxSizing: 'border-box',
            background: '#fff',
            borderRadius: 0
        },
        '& .MuiTabs-indicator':{
            height: 3,
            paddingBottom: 0,
            backgroundColor: '#5579f0'
        }
    },
    boxRole: {
        backgroundColor: '#fff',
        padding: '47px 20px',
        borderRadius: 8,
        height: 130,
        marginBottom: 20,
    },
    textBox: {
        '& .MuiBox-root': {
            padding: '10px 0px',
        },
        '& .MuiFormControl-root': {
            width: '100%',

            '& .MuiInputBase-root': {
                borderRadius: 8,
            }
        }
    },
    disabled: {
        '& .MuiButtonBase-root': {
            background: 'rgba(16, 18, 28, 0.3)',
            color: '#fff',
            '& .MuiTypography-root': {
                color: 'rgba(255, 255, 255, 0.7)',
            }
        },
    },
    buttonStyle: {
        position: 'absolute',
        right: 20,
        '& .MuiButtonBase-root': {
            background: '#f27c57',
            color: '#fff',
            minWidth: 82,
            height: 34,
            '& .MuiTypography-root': {
                fontSize: '0.875rem',
                fontWeight: 'bold',
                color: '#fff',
            }
        },
    },
    formControl:{
        '&.MuiFormControl-root ':{
            margin: 0,
            width: 140,
            marginRight: 12,
        },
        '& .MuiSelect-select':{
            width: 140,
            height: 40,
            padding: '14px 25px 15px 12px !important',
            fontSize: '1.125rem',
            boxSizing:'border-box',
            color:'#777',
            letterSpacing: '-0.5px',
            display:'flex',
            alignItems: 'center',
            background: '#fff',
            border: 'solid 1px #87888d',
            borderRadius: '6px !important',
            '@media all and (max-width: 800px)': {
                width: '100%',
            },
        },
        '& .MuiOutlinedInput-root.Mui-focused .MuiSelect-select':{
            border: '0px solid rgba(117, 0, 250, 0.4)',
            padding: '13px 25px 14px 12px !important',
        },
        '& .MuiOutlinedInput-notchedOutline, .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline, .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline':{
            border: 0,
            borderRadius: 6,
        },
        '& .MuiInput-underline:after, .MuiInput-underline:before': {
            border: 0,
        },
        '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
            border: 0,
        },
        '& .MuiSelect-icon': {
            top: 10,
            right: 6,
        }
    },
    typeOption: {
          '&.MuiTypography-root': {
              fontSize: '1.25rem',
              fontWeight: 'bold',
              marginRight: 14,
          }
    },
    textName: {
        '& .MuiFormControl-root': {
            width: 240,
            height: 40,
            boxSizing: 'border-box',
            marginRight: 10,
        },
        '& .MuiOutlinedInput-root': {
            height: 40
        },
    },
    textListBox: {
        position: 'relative',
        '&.MuiBox-root': {
            width: 'calc(100vw - 550px)',
            border: '1px solid #87888d',
            height: 36,
            borderRadius: 5,
            padding: '1px 12px',
            marginLeft: 20,
            marginRight: 5,
            backGroundColor: '#ccc'
        },
    },
    textField: {
        flex: 1,
        border: "none",
        outline: "none",
        fontSize: "0.875rem",
        letterSpacing: "-0.5px",
    },
    iconButton:{
        padding: 0,
        '&:hover':{
            background: 'transparent'
        }
    },
    volumeIconButton: {
        padding: 0,
        position: 'absolute',
        right: 10,
        top: 5,
        '&:hover':{
            background: 'transparent'
        }
    },
    heightStep2: {
        height: 'calc(100vh - 500px)',
        overflowX: 'auto'
    }


}));












